export var EVENT_TITLE = 'EVENT_TITLE';
export var LOCATION = 'LOCATION';
export var LOCATION_ICON = 'LOCATION_ICON';
export var DESCRIPTION = 'DESCRIPTION';
export var DESCRIPTION_BUTTON = 'DESCRIPTION_BUTTON';
export var RESET_FILTERS_BUTTON = 'RESET_FILTERS_BUTTON';
export var FILTERS_SECTION = 'FILTERS_SECTION';
export var TAGS_SHOW_ALL_BUTTON = 'TAGS_SHOW_ALL_BUTTON';
export var LOCATION_DROPDOWN = 'LOCATION_DROPDOWN';
export var SCHEDULE_TITLE = 'SCHEDULE_TITLE';
export var SCHEDULE_ITEM = 'SCHEDULE_ITEM';
export var SCHEDULE_ITEM_DATETIME = 'SCHEDULE_ITEM_DATETIME';
export var SCHEDULE_ITEM_DURATION = 'SCHEDULE_ITEM_DURATION';
export var SCHEDULE_ITEM_NAME = 'SCHEDULE_ITEM_NAME';
export var MOBILE_SCHEDULE_ITEM = 'MOBILE_SCHEDULE_ITEM';
export var MOBILE_FILTER_MODAL = 'MOBILE_FILTER_MODAL';
export var MOBILE_FILTER_LOCATION_RADIO = 'MOBILE_FILTER_LOCATION_RADIO';
export var MOBILE_FILTER_TAG_CHECKBOX = 'MOBILE_FILTER_TAG_CHECKBOX';
export var MOBILE_FILTER_SUBMIT = 'MOBILE_FILTER_SUBMIT';
export var MOBILE_FILTER_RESET = 'MOBILE_FILTER_RESET';
export var MOBILE_FILTER_BUTTON = 'MOBILE_FILTER_BUTTON';
export var GET_TICKETS_BUTTON = 'GET_TICKETS_BUTTON';
export var CREATE_BOOKMARK = 'CREATE_BOOKMARK';
export var DELETE_BOOKMARK = 'DELETE_BOOKMARK';
export var MY_AGENDA_BUTTON = 'MY_AGENDA_BUTTON';
export var PERSONAL_AGENDA_DONE_BUTTON = 'PERSONAL_AGENDA_DONE_BUTTON';
export var PERSONAL_AGENDA_EMPTY_STATE = 'PERSONAL_AGENDA_EMPTY_STATE';
export var PERSONAL_AGENDA_MODAL_CONTENT = 'PERSONAL_AGENDA_MODAL_CONTENT';
export var TPA_MODAL_CONTENT = 'tpa-modal-content';
export var TAGS_LIST_TAG = 'tags-list-tag';
export var TAGS_LIST_TAG_INPUT = 'tags-list-tag-input';
//# sourceMappingURL=schedule.js.map